module.exports = __webpack_public_path__ + "img/escola_creative_learning_matriculas.1de8e796.jpeg";